import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchPayrollEntityList,
  saveEntity,
  removeEntity,
} from "../store/slices/payrollSlice";

const usePayrollEntity = (entityKey) => {
  const dispatch = useDispatch();
  const entity = useSelector(
    (state) =>
      (state.payroll && state.payroll.entities[entityKey]) || {
        list: [],
        loading: false,
        saving: false,
        msg: null,
      }
  );

  useEffect(() => {
    dispatch(fetchPayrollEntityList(entityKey));
  }, [dispatch, entityKey]);

  return {
    list: entity.list,
    loading: entity.loading,
    saving: entity.saving,
    msg: entity.msg,
    save: (record, isEdit) => dispatch(saveEntity({ entityKey, record, isEdit })),
    remove: (id) => dispatch(removeEntity({ entityKey, id })),
  };
};

export default usePayrollEntity;
